export default function (data, el) {
  this.$el = $(el)

  this.programs = ko.observableArray([])

  this.bindData = data => {
    this.programs(ko.mapping.fromJS(data).programs())
  }

  (() => { this.bindData(data) })()
}
